/*
Copyright @ilogicaly.com 
Includes APIs Endpoint Links

*/

import {webUrl, webUrlNode} from "../constants/appInfo"; 
export const apiUrl = `${webUrl}/wp-json/classmock/v1`;
export const apiUrlNode = `${webUrlNode}/api`;
